var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinInBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin-in-brands",
    d: "M4.477,20.01H.33V6.657H4.477ZM2.4,4.836A2.413,2.413,0,1,1,4.8,2.411,2.422,2.422,0,0,1,2.4,4.836ZM20,20.01H15.858v-6.5c0-1.549-.031-3.536-2.156-3.536-2.156,0-2.486,1.683-2.486,3.424V20.01H7.074V6.657h3.977V8.478h.058a4.357,4.357,0,0,1,3.923-2.156c4.2,0,4.968,2.763,4.968,6.353V20.01Z",
    transform: "translate(0 -0.01)",
    fill: "#2f77b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinInBrands);
export default __webpack_public_path__ + "static/media/linkedin-in-brands.d560b9b44746cf1cc63ea21b15f13913.svg";
export { ForwardRef as ReactComponent };